import { styled, withStyles } from "@mui/styles";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { AbilityContext } from "src/config/ability-context";
import { Styles } from "src/styles/material-styles";
import { bindActionCreators } from "redux";
import { Button, CircularProgress, Container, darken, Grid, IconButton, InputAdornment, Pagination, TextField, Typography } from "@mui/material";
import Header from "src/components/header-external";
import { Overlay } from "src/styles/global";
import CustomizedSnackbars from "src/components/material-snackbars";
import Footer from "src/components/footer-external";
import { Search } from "@mui/icons-material";
import Api from "src/services/api";
import * as componentActions from '../../redux/actions/articles';
import PropTypes from 'prop-types';
import ArticleCard from "./components/ArticleCard";
import DynamicArticles from "src/components/dynamic-articles-external";
import LogoMarca from 'src/images/new-logo2-cmtech.png'
import { PapiroConsole } from "src/utils/papiroConsole";
import { browserHistory } from "src/helpers/history";

const StyledTextField = styled(TextField)({
    backgroundColor: "#fff",
    borderRadius: "14px",
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        }
    }
})

class ArticleListExternal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            articles: [],
            clientportal: {},
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            totalPages: 0,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchvalue: this.props.articles.articlesearch,
            searchtype: this.props.articles.searchtype,
            logoimagesrc: ''
        }

        this.closeNotification = this.closeNotification.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeCreateCalledDialog = this.closeCreateCalledDialog.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    async componentDidMount() {

        document.title = this.state.appName;

        this.setState({ loading: true })

        await this.getHirerId()
        await this.getClientPortal()
        await this.getArticles(1, true)

        this.setState({ loading: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    setPagination(count, page) {

        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count })
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 })
                }
            } else {
                let pageStart = ((page - 1) * 10) + 1
                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 })
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count })
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 })
        }
    }

    getHirerId = async () => {
        const intl = this.props.intl

        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerid: result.data.data.hirerid })
                        else {
                            var l = this.props.match.params.lang;
                            document.location.href = `/${l}/unavailable`
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err)
            })
    }

    async getClientPortal() {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        clientportal: result.data.data
                    })
                    if (result.data.data.logoimage) {
                        this.getFile(result.data.data.logoimage)
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getFile(image)
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    async getArticles(page = 1, mount = false) {

        const { intl } = this.props

        if (!mount) {
            this.setState({ loading: true })
        }

        let url = ``

        PapiroConsole.log("this.state.searchvalue")
        PapiroConsole.log(this.state.searchvalue)
        if (this.state.searchvalue) {
            PapiroConsole.log("entrei aqui 1")
            if (this.state.searchtype == 'text' && this.state.searchvalue.length > 0) {
                url = `articles/paginate/external?page=${page}&hirerid=${this.state.hirerid}&search=${this.state.searchvalue}`
            } else if (this.state.searchtype == 'articlesectionid' && this.state.searchvalue > 0) {
                PapiroConsole.log("entrei aqui 2")
                url = `articles/paginatebyarticlesection/external/${this.state.searchvalue}?page=${page}&hirerid=${this.state.hirerid}`
            } else {
                PapiroConsole.log("entrei aqui 3")
                url = `articles/paginate/external?page=${page}&hirerid=${this.state.hirerid}&search=${this.state.searchvalue}`
            }
        } else {
            PapiroConsole.log("entrei aqui 4")
            url = `articles/paginate/external?page=${page}&hirerid=${this.state.hirerid}`
        }

        await Api.get(url)
            .then(result => {
                if (result.data && result.data.success) {

                    let count = result.data.count
                    this.setState({ count: count })
                    this.setPagination(count, page)

                    this.setState({
                        articles: result.data.data
                    })
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })

        if (!mount) {
            this.setState({ loading: false })
        }
    }

    getFile = async (image) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ logoimagesrc: ImageData.data })
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value
        })
    }

    searchArticle = () => {
        this.props.addCurrentSearch(this.state.searchvalue)
        this.getArticles(1)
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getArticles(page);
    }

    render() {
        const { intl, classes } = this.props
        const { clientportal, articles, hirerid, logoimagesrc } = this.state

        if (this.state.loading) {
            return (
                <>
                    <Overlay>
                        <CircularProgress color='secondary' />
                    </Overlay>
                    <CustomizedSnackbars
                        variant={this.state.notificationVariant}
                        message={this.state.notificationMessage}
                        isOpen={this.state.openNotification}
                        toClose={this.closeNotification}
                    />
                </>
            )
        }

        return (
            <div>
                <main className={classes.contentExternal} >
                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, padding: 0 }}>
                        <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container spacing={4}>
                                <Header
                                    intl={intl}
                                    clientportal={clientportal}
                                    calledservicesettings={clientportal.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                />
                                <Grid item sm={12}>
                                    <div style={{
                                        display: "block",
                                        width: "100vw",
                                        textAlign: "center",
                                        alignContent: "center",
                                        backgroundColor: clientportal.defaultcolor,
                                        paddingBlock: "20px"
                                    }}>
                                        <StyledTextField
                                            name="searchvalue"
                                            label={intl.formatMessage({ id: "search" })}
                                            value={this.state.searchvalue}
                                            onChange={this.handleChange}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    this.searchArticle();
                                                }
                                            }}
                                            sx={{ width: "60vw" }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={_ => this.searchArticle()}>
                                                            <Search />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item sm={12} container marginX="20vw" style={{ maxWidth: '60vw' }} >
                                    <Grid item sm={1}>
                                        {
                                            (clientportal.defaultcolor && clientportal.defaultcolor.length > 0) ?
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={browserHistory.goBack}
                                                    sx={{
                                                        backgroundColor: clientportal.defaultcolor,
                                                        color: '#fff',
                                                        textTransform: 'none',
                                                        '&:hover': {
                                                            backgroundColor: darken(clientportal.defaultcolor, 0.2),
                                                        },
                                                    }}
                                                >
                                                    {intl.formatMessage({ id: "back" })}
                                                </Button>
                                                :
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    onClick={browserHistory.goBack}
                                                    sx={{ textTransform: 'none' }}
                                                >
                                                    {intl.formatMessage({ id: "back" })}
                                                </Button>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item container sm={12} marginX="20vw" spacing={6} style={{ maxWidth: '60vw', paddingLeft: 0 }} >
                                    {
                                        articles && articles.length > 0 ? (
                                            articles.map(article => (
                                                <ArticleCard article={article} />
                                            ))
                                        ) : (
                                            <Grid item xs={12} sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '40px',
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '8px',
                                                textAlign: 'center'
                                            }}>
                                                <Search sx={{ fontSize: 60, color: '#9e9e9e', marginBottom: 2 }} />
                                                <Typography variant="h5" sx={{ color: '#616161', marginBottom: 1 }}>
                                                    {intl.formatMessage({ id: "content.not.found" })}
                                                </Typography>
                                                <Typography variant="body1" sx={{ color: '#757575' }}>
                                                    {intl.formatMessage({ id: "try.different.search" })}
                                                </Typography>
                                            </Grid>
                                        )
                                    }
                                </Grid>
                                <Grid item container marginX="20vw" style={{ marginBottom: 12, marginTop: 8 }}>
                                    <Grid item xs={12} md={3}>
                                        <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                        {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                                    </Grid>
                                </Grid>
                                <Grid item container marginX="20vw" spacing={6} paddingTop={6} >
                                    <Grid item container direction="row" spacing={2} justifyContent="space-around">
                                        {
                                            clientportal.showpromotedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "promoted.articles" })}
                                                hirerid={hirerid}
                                                type="promoted"
                                                count={clientportal.promotedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                        {
                                            clientportal.showbestratedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "best.rated.articles" })}
                                                hirerid={hirerid}
                                                type="bestrated"
                                                count={clientportal.bestratedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                        {
                                            clientportal.showmostviewedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "most.viewed.articles" })}
                                                hirerid={hirerid}
                                                type="mostviewed"
                                                count={clientportal.mostviewedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                        {
                                            clientportal.showrecentarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "recent.articles" })}
                                                hirerid={hirerid}
                                                type="recent"
                                                count={clientportal.recentarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={clientportal.defaulttextcolor}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Footer
                                intl={intl}
                                clientportal={clientportal}
                                setLoading={loading => this.setState({ loading: loading })}
                            />
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
            </div>
        )
    }
}

ArticleListExternal.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    classes: PropTypes.object.isRequired,
    articles: state.articles,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ArticleListExternal)));
ArticleListExternal.contextType = AbilityContext;